module.exports = __webpack_public_path__ + "static/media/trx-color.06426085.png";